var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w100 bg-w"},[_c('iframe',{staticClass:"iframe",attrs:{"src":("/hall/aws/portal/r/w?sid=" + _vm.userToken + "&cmd=com.actionsoft.apps.formui.cachet_home")}})])}
var staticRenderFns = []

export { render, staticRenderFns }